require(process.env.REACT_APP_NAME)



// WEBPACK FOOTER //
// ./src/index.js